import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { MobileNavProvider } from 'features/help/hooks/MobileNavContext';
import { ReactNode } from 'react';
import theme from '../../../theme';
import { HelpLayoutContent } from './HelpLayoutContent';

export default function HelpLayout({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MobileNavProvider>
        <HelpLayoutContent>{children}</HelpLayoutContent>
      </MobileNavProvider>
    </ThemeProvider>
  );
}
